import React from "react";
import { useT } from "@/lib/LanguageContext";

/**
 * The "[Promoted]" label a Promote run buys (crm-decisions.md #6, crm-api-contract.md's
 * Promote bullet: "profile promotions sort first with `promoted:true`"). Renders nothing
 * for a row the payload does not mark — an older cached list without the key must not
 * grow a badge nobody paid for (the same discipline `RatingBadge` applies to `rating`).
 */
export default function PromotedBadge({ promoted, testId, className = "" }) {
  const t = useT("marketplace");
  if (!promoted) return null;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center rounded-full bg-sol-gold px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-black ${className}`}
    >
      {t("promoted.badge")}
    </span>
  );
}
